import React, { Component } from 'react';
import styled from 'styled-components';
import { ImgOverlayContainer } from '../../../../theme/assets';
import { SideColumn, MobileHide } from '../../../../theme/grid';
import { ButtonShow } from '../../../../theme/buttons';

class Typescale extends Component {
  constructor() {
    super();
    this.state = {

      typeBaseline: true,
      typeXheight: true,
      typeCapheight: false,
      typeDescender: false,
      
      selectedBaseline: 'selected',
      selectedXheight: 'selected',
      selectedCapheight: '',
      selectedDescender: ''
    }
  }
  
  showTypeBaseline(e){
    e.preventDefault();
    const { typeBaseline } = this.state;
    this.setState({
      typeBaseline: !typeBaseline
     })
     if (typeBaseline === false) {
       this.setState({
         selectedBaseline: 'selected'
       })
     } else {
       this.setState({
         selectedBaseline: ''
       })
     }
  }
  
  showTypeXheight(e){
    e.preventDefault();
    const { typeXheight } = this.state;
    this.setState({
      typeXheight: !typeXheight
     })
     if (typeXheight === false) {
       this.setState({
         selectedXheight: 'selected'
       })
     } else {
       this.setState({
         selectedXheight: ''
       })
     }
  }
  
  showTypeCapheight(e){
    e.preventDefault();
    const { typeCapheight } = this.state;
    this.setState({
      typeCapheight: !typeCapheight
     })
     if (typeCapheight === false) {
       this.setState({
         selectedCapheight: 'selected'
       })
     } else {
       this.setState({
         selectedCapheight: ''
       })
     }
  }
  
  showTypeDescender(e){
    e.preventDefault();
    const { typeDescender } = this.state;
    this.setState({
      typeDescender: !typeDescender
     })
     if (typeDescender === false) {
       this.setState({
         selectedDescender: 'selected'
       })
     } else {
       this.setState({
         selectedDescender: ''
       })
     }
  }


  render() {
    return (
      <div>
        <MobileHide>
          <SideColumn>
            <h4>Display</h4>
            
            <ButtonShow className={'mozilla ' + this.state.selectedBaseline} onClick={this.showTypeBaseline.bind(this)}>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><g fill="none" fill-rule="evenodd"><ellipse class="light" cx="12" cy="12" fill="#FFC1BF" rx="10" ry="7"/><circle class="dark" cx="12" cy="12" r="4" fill="#FF0900"/><circle cx="15" cy="9" r="2" fill="#FFF"/></g></svg>
              <span>Baseline</span>
            </ButtonShow>
            
            <ButtonShow className={'mozilla ' + this.state.selectedXheight} onClick={this.showTypeXheight.bind(this)}>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><g fill="none" fill-rule="evenodd"><ellipse class="light" cx="12" cy="12" fill="#FFC1BF" rx="10" ry="7"/><circle class="dark" cx="12" cy="12" r="4" fill="#FF0900"/><circle cx="15" cy="9" r="2" fill="#FFF"/></g></svg>
              <span>X-height</span>
            </ButtonShow>
            
            <ButtonShow className={'mozilla ' + this.state.selectedCapheight} onClick={this.showTypeCapheight.bind(this)}>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><g fill="none" fill-rule="evenodd"><ellipse class="light" cx="12" cy="12" fill="#FFC1BF" rx="10" ry="7"/><circle class="dark" cx="12" cy="12" r="4" fill="#FF0900"/><circle cx="15" cy="9" r="2" fill="#FFF"/></g></svg>
              <span>Cap-height</span>
            </ButtonShow>
            
            <ButtonShow className={'mozilla ' + this.state.selectedDescender} onClick={this.showTypeDescender.bind(this)}>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><g fill="none" fill-rule="evenodd"><ellipse class="light" cx="12" cy="12" fill="#FFC1BF" rx="10" ry="7"/><circle class="dark" cx="12" cy="12" r="4" fill="#FF0900"/><circle cx="15" cy="9" r="2" fill="#FFF"/></g></svg>
              <span>Descender</span>
            </ButtonShow>
          </SideColumn>
        </MobileHide>
        <ImgOverlayContainer>

          <img alt="" src={require('../../../../assets/Mozilla/DesignTokens/Typescale/typescale@2x.png')} width="100%" />

          {this.state.typeBaseline && <div>
            <img alt="" src={require('../../../../assets/Mozilla/DesignTokens/Typescale/baseline@2x.png')} width="100%" />
          </div> }
          
          {this.state.typeXheight && <div>
            <img alt="" src={require('../../../../assets/Mozilla/DesignTokens/Typescale/xheight@2x.png')} width="100%" />
          </div> }
          
          {this.state.typeCapheight && <div>
            <img alt="" src={require('../../../../assets/Mozilla/DesignTokens/Typescale/capheight@2x.png')} width="100%" />
          </div> }
          
          {this.state.typeDescender && <div>
            <img alt="" src={require('../../../../assets/Mozilla/DesignTokens/Typescale/decender@2x.png')} width="100%" />
          </div> }

        </ImgOverlayContainer>

      </div>
    );
  }
}

export default Typescale;



// WEBPACK FOOTER //
// src/assets/Mozilla/DesignTokens/Typescale/Typescale.js